import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { IStore } from '../../../../../redux/store';
import {
    TBallastBackendRecord,
} from '../../../../../redux/app/ballast/@types';
import BallastPreviewer from './BallastPreviewer';
import { vesselSelectors } from 'redux/app/vessel';

type OwnProps = {
    ballastRecords: TBallastBackendRecord[];
    isPrintVisible: boolean;
	vesselId: string;
};
type BallastPrintProps = OwnProps & PropsFromRedux;
function BallastPrint(props: BallastPrintProps) {
    const { isPrintVisible, ballastRecords } = props;
    if (!isPrintVisible) return null;
    return (
        <div className="w-full p-12">
            <div className="mb-8">
                <h2 className="text-xl font-bold font-redhat-display">
                    Ballast record book
                </h2>
            </div>
            <div className="w-full bg-gray-100">
                <table className="w-full bg-gray-100 marpol-table ballast-table">
                    <thead>
                        <tr className="bg-gray-100">
                            <th>
                                <div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600 bg-gray-200 border-gray-300 whitespace-nowrap min-w-20">
                                    Date
                                    <span className="invisible">
                                        {' '}
                                        and Time (UTC)
                                    </span>
                                </div>
                            </th>
                            <th>
                                <div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-right text-gray-600 bg-gray-200 border-gray-300 whitespace-nowrap min-w-20">
                                    Code
                                </div>
                            </th>
                            <th>
                                <div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-right text-gray-600 bg-gray-200 border-gray-300 whitespace-nowrap min-w-20">
                                    Item
                                </div>
                            </th>
                            <th>
                                <div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600 bg-gray-200 border-gray-300 whitespace-nowrap min-w-20">
                                    Record of Operations
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {ballastRecords.map((ballastRecord, index) => {
                            return (
                                <BallastPreviewer
                                    key={ballastRecord.id}
                                    ballastRecord={ballastRecord}
                                    isPrint={true}
                                    theme="light"
                                />
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const vesselStore = vesselSelectors._getStore(store);
	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);
    return {
        vesselName: vesselInfo?.vesselName,
        imoNumber: vesselInfo?.imoNumber,
    };
}
const reduxConnector = connect(mapStateToProps, {});
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(BallastPrint);
